import { render, staticRenderFns } from "./TargetingLocation.vue?vue&type=template&id=21cdbfb6&"
import script from "./TargetingLocation.vue?vue&type=script&lang=js&"
export * from "./TargetingLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports